// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from 'components/styles/_media'
import TopicItemCard, {
  type PropTypes as TopicItemCardTypes,
} from 'components/molecules/TopicListItem'
import Colors from 'components/styles/colors'
import type { Topic } from 'types/www/topic'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'

type PropTypes = {
  title: string,
  content: string,
  image: string,
  buttonTitle: string,
  linkUrl: string,
}

export default (props: PropTypes) => {
  const imageUrl = imageURLWithTransform(props.image, {
    width: 670,
    height: 400,
    crop: 'fill',
  })
  return (
    <li className="mediumlist__item">
      <p className="mediumlist__img center-img">
        <a href={props.linkUrl}>
          <OptimizedImage src={imageUrl} alt={props.title} />
        </a>
      </p>
      <p className="mediumlist__spacename">
        <a href={props.linkUrl}>{props.title}</a>
      </p>
      <p className="mediumlist__text">{props.content}</p>
      {(() => {
        if (props.linkUrl.length > 0 && props.buttonTitle.length > 0) {
          return (
            <p className="mediumlist__link">
              <a href={props.linkUrl} className="textlink-arrow cl_blue">
                {props.buttonTitle}
              </a>
            </p>
          )
        }
      })()}
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/TopicContentItem/ThreeColumn/index.jsx